"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAutomation = instanceOfAutomation;
exports.AutomationFromJSON = AutomationFromJSON;
exports.AutomationFromJSONTyped = AutomationFromJSONTyped;
exports.AutomationToJSON = AutomationToJSON;
/**
 * Check if a given object implements the Automation interface.
 */
function instanceOfAutomation(value) {
    if (!('content' in value) || value['content'] === undefined)
        return false;
    return true;
}
function AutomationFromJSON(json) {
    return AutomationFromJSONTyped(json, false);
}
function AutomationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'content': json['content'],
    };
}
function AutomationToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'content': value['content'],
    };
}
